export const GLOBAL_SEARCH_EVENT = "Global Search";
export const GLOBAL_SEARCH_STEPS = {
  ENTRY: "Entry",
  SUCCESS: "Success"
};
